module.exports = __webpack_public_path__ + "static/media/client-interview-schedular-icon.35349539.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client-interview-schedular-icon.svg
// module id = 1017
// module chunks = 1